/* eslint-disable */
// import axios from 'axios'
import axios from '../../helpers/Axios'
import { Promise } from 'es6-promise';

export const fileuploadmodule = {
	namespaced: true,
	state: {
		lastFileUpload: {
			filename: null,
			extension: null,
			companyNumbers: []
		}
	},
	getters: {
		companyIds: state => { return state.companyIds; }
	},
	actions: {
		uploadFileOfCompanyIds({ commit }, formData) {
			return axios({
				method: 'post',
				url: '/fileupload/upload-file-of-company-ids',
				data: formData
			}).then(response => {
				commit('setUploadedFile', response.data);
			});
		}
	},
	mutations: {
		setUploadedFile(state, { filename, extension, companyNumbers }) {
			state.lastFileUpload.fileName = filename;
			state.lastFileUpload.extension = extension;
			state.lastFileUpload.companyNumbers = companyNumbers;
		}
	}
}
